export function readLegacyVisitedIds(value: unknown, scopePrefix: string): string[] {
    if (!Array.isArray(value)) {
        return [];
    }
    const ids = new Set<string>();
    for (const row of value) {
        if (typeof row !== "string" || !row.startsWith(scopePrefix)) {
            continue;
        }
        const contextId = row.slice(scopePrefix.length);
        const match = /^global:(.+)$/.exec(contextId)
            ?? /^destination:[^:\s]+:[^:\s]+:(.+)$/.exec(contextId)
            ?? /^tour:[^:\s]+:[^:\s]+:[^:\s]+:(.+)$/.exec(contextId);
        if (match?.[1].trim()) {
            ids.add(match[1]);
        }
    }
    return Array.from(ids);
}
